import { Pipe, PipeTransform } from '@angular/core';
import { FloorClass } from '../../../../models/floor.class';

@Pipe({
  name: 'isFloorIndexValid',
  standalone: false,
})
export class IsFloorIndexValidPipe implements PipeTransform {
  transform(floor: FloorClass): boolean {
    return floor.isIndexValid();
  }
}

@Pipe({
  name: 'isFloorIndexEqualToInvalidIndexValue',
  standalone: false,
})
export class IsFloorIndexEqualToInvalidIndexValuePipe implements PipeTransform {
  transform(value: FloorClass): boolean {
    return value.floorIndex === FloorClass.InvalidIndex;
  }
}
